var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23416 13.4137L7.60278 9.31842H14.2185L12.3554 11.1871C12.2323 11.3106 12.2323 11.513 12.3554 11.6364C12.4784 11.7598 12.6802 11.7598 12.8033 11.6364L15.2079 9.22464C15.331 9.10125 15.331 8.89878 15.2079 8.77536L12.8033 6.36361C12.6802 6.24018 12.4784 6.24018 12.3554 6.36361C12.2323 6.48704 12.2323 6.68946 12.3554 6.81288L14.2185 8.68156H7.60278L3.23416 4.58627C3.10617 4.46532 2.90435 4.47272 2.78622 4.60109C2.66807 4.72945 2.673 4.93187 2.80098 5.05036L7.01456 9L2.80099 12.9496C2.673 13.0706 2.66562 13.2706 2.78622 13.3989C2.90682 13.5273 3.10617 13.5346 3.23416 13.4137Z",
    fill: "#4D555E",
    stroke: "#4D555E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerge);
export default __webpack_public_path__ + "static/media/merge.f48678d6fe5cbcfdeafa6da76c1bab5d.svg";
export { ForwardRef as ReactComponent };